<template>
	<span class="help-feedback" :for="forElementId">{{ helpText }}</span>
</template>

<script>
export default {
	name: 'HelpFeedback',
	props: {
		helpText: {
			type: String,
			default: ''
		},
		forElementId: {
			type: [String, Number],
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>

.help-feedback {
	display: inline-block;
	font-family: $font-family;
	font-size:  $default-font-size - 4;
	margin-top: $gutter-sm;
	color:$neutral-2;
}
</style>
